module.exports = __webpack_public_path__ + "img/http-desc-expand.63e5112b.svg";